// Copyright © 2021 Move Closer

import { AnyObject } from '@movecloser/front-core'
import { AbstractTypeDriver } from './abstract'
import { DescriptionOfSmartLink, RelatedType } from '../contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export class SmartTagDriver<M extends AnyObject = DescriptionOfSmartLink, D extends AnyObject = M> extends AbstractTypeDriver<M, D> {
  /**
   * Key that stores RelatedType.
   * @protected
   */
  protected typeKey: RelatedType = RelatedType.SmartTag
}
